export const AuthenticationFactorTypes = {
  TOTP: "TOTP",
  RECOVERY_CODE: "RECOVERY_CODE",
} as const;

export type AuthenticationFactorType =
  typeof AuthenticationFactorTypes[keyof typeof AuthenticationFactorTypes];
